module.exports = __webpack_public_path__ + "img/purtion.0f04fde8.jpg";